export default __webpack_public_path__ + "static/1_2-156a791478f2b4338525e3a8bf1ecfab.jpeg";